import { useRef, useEffect, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';
import { useAppDispatch } from '../../store/hooks';
import { setCanvas } from '../../modules/draw/drawSlice';

const StyledCanvas = styled('canvas')({
  top: 0,
  left: 0,
  width: 301,
  height: 301,
});

interface CanvasProps extends HTMLAttributes<HTMLCanvasElement> {
  className?: string;
}

export default function Canvas({ className = '', ...rest }: CanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const context = canvas.getContext('2d');
    if (!context) return;

    dispatch(setCanvas({ name: context.canvas.id as keyof import('../../types').DrawState, data: canvas }));

    return () => {
      dispatch(setCanvas({ name: context.canvas.id as keyof import('../../types').DrawState, data: null }));
    };
  }, [dispatch]);

  return (
    <StyledCanvas
      ref={canvasRef}
      width="301"
      height="301"
      {...rest}
      className={className}
    />
  );
}
